module.exports = __webpack_public_path__ + "img/gather.3a19718e.png";